import apiService from '../apiService';
import UserModel from '@/pages/apps/users/models/UserModel';

export const addTagTypes = ['roles', 'users', 'user'] as const;

export const usersApi = apiService
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getRoles: build.query<any, any>({
        query: () => ({ url: `role` }),
        providesTags: ["roles"],
      }),
      getUsers: build.query<any, any>({
        query: ({ key_search, role_id, page, per_page, pagination }) => ({
          url: `user`,
          params: { key_search, role_id, page, per_page, pagination },
        }),
        providesTags: ["users"],
      }),
      getCustomer: build.query<any, any>({
        query: ({ search, role_id, page, per_page }) => ({
          url: `manufacturer/user`,
        }),
      }),
      deleteUser: build.mutation<any, any>({
        query: (userId) => ({
          url: `user/delete/${userId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["users"],
      }),
      createUser: build.mutation<any, any>({
        query: (newUser) => ({
          url: `user/store`,
          method: "POST",
          body: UserModel(newUser),
        }),
        invalidatesTags: ["users"],
      }),
      updateUser: build.mutation<any, any>({
        query: (user) => ({
          url: `user/update`,
          method: "PUT",
          body: user,
        }),
        invalidatesTags: ["users"],
      }),
      getUser: build.query<any, any>({
        query: (userId) => ({
          url: `user/show/${userId}`,
        }),
        providesTags: ["user", "users"],
      }),
      updateUserStatus: build.mutation<any, any>({
        query: (data) => ({
          url: `user/change-status`,
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["users"],
      }),
      updateUserVerification: build.mutation<any, any>({
        query: (data) => ({
          url: `user/change-verification`,
          method: "PUT",
          body: data,
        }),
        invalidatesTags: ["users"],
      }),
    }),
    overrideExisting: true,
  });

export const {
  useGetUsersQuery,
  useGetCustomerQuery,
  useDeleteUserMutation,
  useCreateUserMutation,
  useUpdateUserMutation,
  useGetUserQuery,
  useGetRolesQuery,
  useUpdateUserStatusMutation,
  useUpdateUserVerificationMutation,
} = usersApi;

export type User = {
  is_verified: any;
  status: number;
	id: string;
	name: string;
	email: string;
	phone: string;
	address: string;
	role: {
		name: string;
		role_id: string;
	};
	role_id: string;
};
